<div class="content-wrapper container-xxl p-0">
	<div class="content-body">

	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<form id="formPedidoIsencao" [formGroup]="form" (ngSubmit)="submit()">
	<section class="invoice-add-wrapper">
		<div class="row invoice-add">
			<div class="col-xl-9 col-md-8 col-12">
				<div class="card invoice-preview-card">
					
					<div class="card-body invoice-padding pb-0">
						<div class="row row-bill-to invoice-spacing">
							<div class="col-xl-7 mb-lg-1 col-bill-to pl-0">
								<h4 class="invoice-to-title">Cliente:</h4>
								<input type="text" class="form-control float-left" placeholder="CPF, CNPJ ou Nome do cliente"
									(keyup)="onKeyUp($event)" [(ngModel)]="termoPesquisa" [ngModelOptions]="{standalone: true}" matInput [matAutocomplete]="auto" />
								<span *ngIf="carregando" class="float-left spinner-border spinner-border-sm loading-suffix"></span>

								<mat-autocomplete #auto="matAutocomplete">
									<mat-option *ngFor="let option of clientes" [value]="option.nome_contratante || option.razao_social || option.nome_fantasia || option.nome" (click)="setCliente(option)">
									{{ option.nome_contratante || option.razao_social || option.nome_fantasia || option.nome }}
									</mat-option>
								</mat-autocomplete>
								<br>
								<br>
								<span *ngIf="clienteNaoEncontrado" style="color: red;">Nenhum cliente encontrado.</span>
							</div>
						
							<div class="col-xl-5 pl-0 pl-xl-1 pl-md-0 mt-xl-0 mt-2">
								
									<h6>Detalhes do cliente:</h6>
									<span *ngIf="selectedCliente == null"><strong>Selecione um cliente</strong></span>
									<table *ngIf="selectedCliente != null">
									<tbody>
										<tr>
											<td class="pr-1">Contratante:
												<br>
												{{selectedCliente.nome_contratante}}
											</td>
										</tr>
											<tr>
												<td class="pr-1">Email:<br>
												{{selectedCliente.email_cliente == null ? '-' : selectedCliente.email_cliente}}
											</td>
										</tr>
										<tr>
											<td class="pr-1">N. fantasia:<br>
												{{selectedCliente.nome_fantasia}}
											</td>
										</tr>
										<tr>
											<td class="pr-1">Razao social:<br>
												{{selectedCliente.razao_social}}
											</td>
										</tr>
									</tbody>
									</table>
								
							</div>
						</div>
					</div>
					
					<hr class="invoice-spacing" />
					<div class="card-body invoice-padding invoice-product-details">
						<h3 style="font-size: 20px; font-weight: bold; margin-top: -35px;">
							<i data-feather="codepen" class="mr-25"></i>
							Produtos
						</h3>
						<br><br>
						<div class="row">
							<div class="col-lg-3 col-12 mb-lg-0 mb-2 mt-lg-0 mt-2">
								<p class="card-text col-title mb-md-50 mb-0">Item </p>
								<select class="form-control" formControlName="id_produto">
									<option [ngValue]="null">-- Selecione --</option>
									<option *ngFor="let p of produtos" [ngValue]="p.id_produto">{{ p.nome }}</option>
								</select>
							</div>

							<div class="col-lg-2 col-12 my-lg-0 my-2">
								<p class="card-text col-title mb-md-50 mb-0">Ação</p>
								<button type="button"
									(click)="modalProdutoOpen(modalProdutos, form.value)"
									[disabled]="form.value.id_produto == null"
									class="btn btn-outline-secondary btn-apply-changes mr-1 mb-1"
									rippleEffect>
									Incluir
								</button>
							</div>
						</div>
					</div>

					<hr class="invoice-spacing" />
					<div class="card-body invoice-padding invoice-product-details" style="background-color: #fff;">
						
						<div *ngIf="itens.length === 0" class="text-center mt-2">
							<p class="text-muted">Nenhum item adicionado.</p>
						</div>
						
						<div *ngIf="itens.length > 0">
							<!-- Grid com paginação -->
							<div class="table-responsive">
								<table class="table table-hover">
									<thead>
										<tr>
											<th>#</th>
											<th>Descrição</th>
											<th>Quantidade</th>
											<th>Ações</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let item of itensPaginados; let i = index">
											<td>{{ (paginacao.pagina - 1) * paginacao.itensPerPage + i + 1 }}</td>
											<td>{{ item.descricao }}</td>
											<td>{{ item.quantidade }}</td>
											<td>
												<button type="button" class="btn btn-sm btn-outline-danger" 
													(click)="removerItem((paginacao.pagina - 1) * paginacao.itensPerPage + i)"
													title="Remover item">
													<i data-feather="trash-2" [size]="14"></i>
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!-- Paginação -->
							<nav *ngIf="(paginacao.total > paginacao.itensPerPage)" class="mt-3" aria-label="Page navigation">
								<ul class="pagination justify-content-center">
									<li class="page-item" [class.disabled]="paginacao.pagina === 1">
										<button class="page-link" (click)="mudarPagina(1)" [disabled]="paginacao.pagina === 1">Primeira</button>
									</li>
									<li class="page-item" [class.disabled]="paginacao.pagina === 1">
										<button class="page-link" (click)="mudarPagina(paginacao.pagina - 1)" [disabled]="paginacao.pagina === 1">Anterior</button>
									</li>
									<li class="page-item active">
										<span class="page-link">{{ paginacao.pagina }} / {{ Math.ceil(paginacao.total / paginacao.itensPerPage) }}</span>
									</li>
									<li class="page-item" [class.disabled]="paginacao.pagina === Math.ceil(paginacao.total / paginacao.itensPerPage)">
										<button class="page-link" (click)="mudarPagina(paginacao.pagina + 1)" [disabled]="paginacao.pagina === Math.ceil(paginacao.total / paginacao.itensPerPage)">Próximo</button>
									</li>
									<li class="page-item" [class.disabled]="paginacao.pagina === Math.ceil(paginacao.total / paginacao.itensPerPage)">
										<button class="page-link" (click)="mudarPagina(Math.ceil(paginacao.total / paginacao.itensPerPage))" [disabled]="paginacao.pagina === Math.ceil(paginacao.total / paginacao.itensPerPage)">Última</button>
									</li>
								</ul>
							</nav>
						</div>
					</div>						
					<!-- <div class="mt-3">
						<button type="submit" form="formPedidoIsencao" class="btn btn-primary" [disabled]="loading">
							<span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
							<span>Salvar Pedido</span>
						</button>
						<button type="button" class="btn btn-secondary ml-2" (click)="voltarListagem()">Cancelar</button>
					</div> -->
				</div>
			</div>

		<div class="col-xl-3 col-md-4 col-12 mt-md-0 mt-2">
			<div class="card">
				<div class="card-body">
					<h4>Resumo do Pedido</h4>
					<div class="mt-3">
						<div class="d-flex justify-content-between align-items-center mb-3">
							<strong>Total de Itens:</strong>
							<div class="d-flex align-items-center">
								<span class="badge badge-success badge-pill mr-2">{{ itens.length }}</span>
								<button type="button" class="btn btn-sm btn-outline-danger" 
									(click)="removerTodos()"
									[disabled]="itens.length === 0"
									title="Remover todos os itens">
									<i data-feather="trash-2" [size]="16"></i>
								</button>
							</div>
						</div>
					</div>
					<div class="form-group mt-2">
						<label for="basicSelect">Data de Compra:</label>
						<div class="input-group" *ngIf="pedido.id_pedido == null">
							<input class="form-control" placeholder="Selecione a data" required
								[disabled]="pedido.id_status == 2" name="dt_compra"
								[(ngModel)]="pedido.dt_contrato" ngbDatepicker #dp="ngbDatepicker" formControlName="dt_compra"/>
							<button class="btn btn-outline-secondary bi feather icon-calendar"
								[disabled]="pedido.id_status == 2" (click)="dp.toggle()" type="button"></button>
						</div>
						<div *ngIf="pedido.id_pedido">
							<span>{{pedido.dt_compra | date}}</span>
						</div>
					</div>

					<div class="form-group mt-2">
						<label for="basicSelect">Data de Isenção:</label>
						<div class="input-group" *ngIf="pedido.id_pedido == null">
							<input class="form-control" placeholder="Selecione a data" required
								[disabled]="pedido.id_status == 2" name="dt_fim_isencao"
								[(ngModel)]="pedido.dt_fim_isencao" ngbDatepicker #dp="ngbDatepicker" formControlName="dt_fim_isencao" />
							<button class="btn btn-outline-secondary bi feather icon-calendar"
								[disabled]="pedido.id_status == 2" (click)="dp.toggle()" type="button"></button>
						</div>
						<div *ngIf="pedido.id_pedido">
							<span>{{pedido.dt_fim_isencao | date}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-body">
					<button type="button" class="btn btn-primary btn-block mb-75" (click)="voltarListagem()">Cancelar</button>
					<button type="submit" form="formPedidoIsencao" class="btn btn-outline-primary btn-block mb-75" [disabled]="loading" ><span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
							<span>Salvar Pedido</span></button>					
				</div>
			</div>
		</div>		</div>

		<!-- Modal produtos -->
		<ng-template #modalProdutos let-modal>
			<div class="modal-header">
				<h2 class="modal-title" id="myModalLabel1">Incluir Produtos</h2>
				<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body" tabindex="0" ngbAutofocus>
				<p class="mb-2"><strong>Digite os itens separados por linha:</strong></p>
				<textarea class="form-control" rows="8" [(ngModel)]="modalProdutosConteudo" 
					placeholder="Item 1&#10;Item 2&#10;Item 3&#10;..." [ngModelOptions]="{standalone: true}"></textarea>
				<small class="text-muted">Cada linha será um item do pedido.</small>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cancelado')">Cancelar</button>
				<button type="button" class="btn btn-primary" (click)="confirmarItens()">Confirmar</button>
			</div>
		</ng-template>
		<!-- / Modal produtos-->
	</section>
	</form>	
	</div>
</div>